import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Flow45_1Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Flow45_1 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("WASTE_PROCESSING_FINAL_TREATMENT") || "Waste processing - final treatment"}
        subDescription={t("WASTE_PROCESSING_FINAL_TREATMENT_DESC") || "This is the final operation applied to waste that cannot be recovered, such as landfill disposal or incineration without energy recovery. It represents the definitive end of the material's life, where it no longer re-enters any recovery chain."}
        isNormal={true}
        number={"45.1"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`flow-45-1-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Flow45_1Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Flow45_1;

